import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import TextInput from './TextInput';

type SearchBarProps = {
	noFlex?: boolean;
	bootstrap?: boolean;
	noboxshadow?: boolean;
	noicon?: boolean;
	quoteType?: string;
	style?: React.CSSProperties;
	placeholder?: string;
	onChange: (value: string) => void;
};

const SearchBar = ({
	noFlex = false,
	bootstrap = false,
	noboxshadow = false,
	noicon = false,
	quoteType = '',
	style = {},
	placeholder = '',
	onChange,
}: SearchBarProps) => (
	<div
		style={{
			display: noFlex ? 'unset' : 'flex',
			alignItems: bootstrap ? '' : 'center',
			alignSelf: bootstrap ? '' : 'center',
			boxShadow: noboxshadow ? '' : '0 0 0 1px gray',
			borderRadius: '3px',
		}}
	>
		{!noicon ? (
			<FontAwesomeIcon
				icon={faSearch}
				className={`text-${quoteType}`}
				style={{
					marginTop: '0.1em',
					padding: '0.25em 0.45em',
					fontSize: '0.8em',
					lineHeight: '1.3em',
					borderRadius: '3px',
				}}
			/>
		) : null}
		<TextInput
			onChange={onChange}
			style={{ ...{ boxShadow: 'none' }, ...style }}
			placeholder={placeholder || 'Search'}
			bootstrap={bootstrap}
		/>
	</div>
);

export default SearchBar;
